import { createStandardAction } from 'typesafe-actions';
export const useApiQueryActions = {
    /**
     * Resets to the default state.
     *
     * This is useful if no request params are passed to the hook.
     */
    reset: createStandardAction('RESET')(),
    /**
     * A request has begun.
     */
    request: createStandardAction('REQUEST')(),
    /**
     * A refetchRequest has begun.
     */
    refetchRequest: createStandardAction('REFETCH_REQUEST')(),
    /**
     * A request (or refetchRequest) has completed.
     */
    success: createStandardAction('SUCCESS')(),
    /**
     * A request (or refetchRequest) has failed.
     */
    failure: createStandardAction('FAILURE')(),
    /**
     * The `data` should be set manually.
     */
    setData: createStandardAction('SET_DATA')()
};
//# sourceMappingURL=actions.js.map